import React from 'react'
import { useParams } from 'react-router-dom'
import { Loader2, AlertCircle } from 'lucide-react'
import { useCase } from '../hooks/useCase'
import { DocumentsView } from '../components/documentsView'
import styles from './DocumentsPage.module.css'

const DocumentsPage: React.FC = () => {
  const { caseId } = useParams<{ caseId: string }>()
  const { caseData, loading: caseLoading, error: caseError } = useCase(caseId)

  if (caseLoading) {
    return (
      <div className={styles.container}>
        <div className={styles.loadingState}>
          <Loader2 size={32} className={styles.spinner} />
          <span>Loading case...</span>
        </div>
      </div>
    )
  }

  if (caseError) {
    return (
      <div className={styles.container}>
        <div className={styles.errorState}>
          <AlertCircle size={32} />
          <span>{caseError.message}</span>
        </div>
      </div>
    )
  }

  if (!caseData || !caseId) {
    return (
      <div className={styles.container}>
        <div className={styles.errorState}>
          <AlertCircle size={32} />
          <span>Case not found</span>
        </div>
      </div>
    )
  }

  return <DocumentsView caseData={caseData} caseId={caseId} />
}

export default DocumentsPage
